import React, { useMemo } from 'react';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { theme } from '../../styles/constants';
import OrganizationAnalyticsChartCard from './OrganizationAnalyticsChartCard';
import { CHART_COLORS, formatValueByType, getDefaultTooltipFormatter } from './chartUtils';

const OrganizationAnalyticsLineChart = ({
  title,
  subtitle,
  categories,
  series,
  pending,
  emptyText,
  valueType = 'currency',
  tooltipFormatter,
  tooltipShared = true,
}) => {
  const chartSeries = useMemo(() => series.filter(item => item.data?.length), [series]);
  const hasData = categories.length > 0 && chartSeries.length > 0;
  const visibleCategoryCount = 7;
  const fullChartWidth = Math.max(categories.length, visibleCategoryCount) * 88;

  const options = useMemo(
    () => ({
      chart: {
        backgroundColor: '#fff',
        type: 'line',
        scrollablePlotArea:
          categories.length > visibleCategoryCount
            ? {
                minWidth: fullChartWidth,
                scrollPositionX: 1,
                opacity: 1,
              }
            : undefined,
        style: {
          fontFamily: 'Lexend',
        },
      },
      title: {
        text: '',
      },
      accessibility: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      legend: {
        itemStyle: {
          color: theme.colors.textColor,
          fontSize: 12,
        },
      },
      xAxis: {
        categories,
        labels: {
          style: {
            color: theme.colors.textColor,
            fontSize: 11,
          },
        },
        gridLineColor: '#F3F4F6',
        gridLineDashStyle: 'Dot',
        gridLineWidth: 1,
      },
      yAxis: {
        title: {
          text: '',
        },
        gridLineColor: '#F3F4F6',
        gridLineDashStyle: 'Dot',
        labels: {
          formatter: function () {
            return formatValueByType(this.value, valueType);
          },
          style: {
            color: theme.colors.textColor,
            fontSize: 12,
          },
        },
      },
      plotOptions: {
        series: {
          lineWidth: 3,
          marker: {
            enabled: true,
            radius: 3,
          },
        },
      },
      colors: CHART_COLORS,
      tooltip: {
        shared: tooltipShared,
        style: {
          fontSize: 12,
        },
        formatter: tooltipFormatter || getDefaultTooltipFormatter(valueType),
      },
      series: chartSeries,
    }),
    [categories, chartSeries, fullChartWidth, tooltipFormatter, tooltipShared, valueType],
  );

  return (
    <OrganizationAnalyticsChartCard
      title={title}
      subtitle={subtitle}
      pending={pending}
      hasData={hasData}
      emptyText={emptyText}>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </OrganizationAnalyticsChartCard>
  );
};

export default OrganizationAnalyticsLineChart;
